import React, {Component, lazy, Suspense} from 'react';
import moment from 'moment';

import {AppContext} from '../../../../AppModule/Context';
import {withWidgetContext} from '../../../widgetComponent/widgetContextProvider';

import ClientSchedulingInvitationComponent from '../personalPage/clientSchedulingInvitationComponent';
import MultipleTextPillComponent from '../../multipleTextPillComponent/multipleTextPillComponent';
import NotificationComponent from '../../../common/genericComponents/notificationComponent';
import SchedulingInWidgetStep1 from './schedulingInWidgetStep1';
import SchedulingInWidgetStep2 from './schedulingInWidgetStep2';
import SchedulingInWidgetStep3 from './schedulingInWidgetStep3';
import SuspenseLoader from '../../../common/genericComponents/suspenseLoader/suspenseLoader';

import bookingFlowService from '../../../../services/restServices/bookingFlowInstanceService';
import sessionTemplateService from '../../../../services/restServices/sessionTemplateService';
import userService from '../../../../services/restServices/userService';
import utilsService from '../../../../services/utilsService';

import scheduleUtils from '../../scheduleUtils';
import VIDABOO_CONSTANTS from '../../../../config/consts';
import STRINGS from '../../../../config/strings';

const C2cPaymentComponent = lazy(
  () => import('../../../paymentRequestComponent/c2cPaymentComponent'),
);

import './clientScheduleRequestContainer.css';

const DAY = 1000 * 60 * 60 * 24;
const DEFAULT_SESSION_TIME = 1000 * 60 * 30;
const TIME_STEP_MINUTES = 30;
const TIME_STEP = 1000 * 60 * TIME_STEP_MINUTES;
class ClientScheduleRequestContainer extends Component {
  constructor(props) {
    super(props);
    this.isTeamMentor =
      props.mentor.mentorDto.mentorOwnerType ===
      VIDABOO_CONSTANTS.MENTOR_OWNER_TYPE.WIDGET;
    this.mentorsControlMapDto = props.widgetDto?.mentorsControlMapDto;
    this.state = {
      bookingOptions: [],
      alreadyBookedTimeRanges: null,
      alreadyBookedTimeRangesStartDate: null,
      alreadyBookedTimeRangesEndDate: null,
      isLoading: false,
      showSuccessComponent: false,
      isBookingFlowRunning: false,
      recipients: [],
      areAllEmailsValid: true,
      paymentFlowBasedSessionDto: null,
      shouldRestartSchedulingFlow: false,
      paymentDtoBfiId: null,
      shouldStartPaymentFlow: false,
      selectedTimezone: null,
      availableSlotsListsByDate: {},
      selectedMentorForTeamScheduling: null,
    };
  }

  componentDidMount = () => {
    if (
      !this.props.mentor?.mentorDto?.scheduleSettingsDto?.autoMentorApproval
    ) {
      const startTime = moment().startOf('day').valueOf();
      this.generateMentorAvailabilityListForMonth(startTime);
    }
    if (this.props.mentor?.mentorDto?.scheduleSettingsDto?.autoMentorApproval) {
      const startTime = moment().startOf('day').valueOf();
      const endTime = moment().endOf('month').endOf('day').valueOf();
      this.setAlreadyBookedTimeRanges(startTime, endTime, true);
      if (!this.isTeamMentor) {
        this.handlePaymentFlowBasedSessionDto();
      }
    }

    const initialBookingOption = this.createNewBookingOption();
    this.setState({
      bookingOptions: [initialBookingOption],
      schedulingStep: 0,
      bookingFlowInstance: {
        sessionTemplateId:
          this.props.mentor.sessionTemplateDto?.sessionTemplateId,
        recipientUserId: this.props.mentor.mentorDto.mentorOwnerId,
        mentorUserId: this.props.mentor.mentorDto.mentorOwnerId,
        mentorId: this.props.mentor.mentorDto.mentorId,
        title: scheduleUtils.getMeetingTitle(
          this.props.mentor.mentorDto.displayName,
          this.props.mentor.sessionTemplateDto,
        ),
        recipients: [
          {
            userId: this.props.mentor.mentorDto.mentorOwnerId,
            status: VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CREATED,
            isValid: false,
          },
        ],
      },
      requestedTimezone: scheduleUtils.generateGuessedTimezone(),
    });
  };

  generateMentorAvailabilityListForMonth = (
    newSelectedStartTime,
    recreateBookingOption = true,
    updateAlreadBookedRanges = false,
  ) => {
    if (!this.mentorsControlMapDto) {
      return;
    }
    if (updateAlreadBookedRanges && newSelectedStartTime) {
      // incase generateMentorAvailabilityListForMonth is called directly for an older month
      const startTime = newSelectedStartTime;

      const endTime = moment(newSelectedStartTime)
        .tz(
          this.state.requestedTimezone ||
            scheduleUtils.generateGuessedTimezone(),
        )
        .endOf('month')
        .endOf('day')
        .valueOf();
      this.setState({
        alreadyBookedTimeRangesStartDate: startTime,
        alreadyBookedTimeRangesEndDate: endTime,
      });
    }
    const selectedTimezone =
      this.state.requestedTimezone || scheduleUtils.generateGuessedTimezone();
    const selected =
      newSelectedStartTime ??
      (this.props.mentor?.mentorDto?.scheduleSettingsDto?.autoMentorApproval
        ? this.state.alreadyBookedTimeRangesStartDate
        : moment().tz(selectedTimezone).startOf('day').valueOf());

    const selectedMonthYear = moment
      .tz(selected, selectedTimezone)
      .format('MMM YYYY');
    const daysArray = scheduleUtils.generateDaysArray(
      moment(selectedMonthYear, ['MMM YYYY']).format('YYYY'),
      moment(selectedMonthYear, ['MMM YYYY']).format('MM'),
      this.props.mentor?.mentorDto?.scheduleSettingsDto?.weekStartDay,
    );

    const timeFormat =
      this.props.mentor.mentorDto?.scheduleSettingsDto.timeFormat;
    const timeIntervals =
      this.props.mentor?.mentorDto?.scheduleSettingsDto?.startTimeSlotJumps ||
      TIME_STEP_MINUTES;
    let dayTimesArray = scheduleUtils.generateTimeIntervals(
      '00:00',
      timeIntervals,
      'minutes',
      timeFormat,
    );

    const validTimeRanges =
      this.props.mentor.mentorDto.scheduleSettingsDto
        .availableTimeRangesSelector ===
      VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.SPECIFIC_TIME
        ? this.props.mentor.mentorDto.scheduleSettingsDto.availableTimeRanges ||
          []
        : this.props.mentor.mentorDto.scheduleSettingsDto
              .availableTimeRangesSelector ===
            VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.NO_TIME
          ? []
          : null;

    const minDate = scheduleUtils.getMinDate(
      this.props.mentor.mentorDto?.scheduleSettingsDto.minTimeBeforeBooking,
      selectedTimezone,
    );
    const maxDate = this.props.maxDate;
    const sessionTimeLimit =
      this.props.mentor?.sessionTemplateDto?.sessionTimeLimit * 60 * 1000;
    const selectedYear = moment(selectedMonthYear, ['MMM YYYY']).format('YYYY');
    const selectedMonth = moment(selectedMonthYear, ['MMM YYYY']).format('MM');

    // reset the available slots list and generate optimized time slots
    this.setState(
      {availableSlotsListsByDate: {}, selectedMentorForTeamScheduling: null},
      () => {
        // Step 1: Generate all time slots for the month in one pass
        const allTimeSlots = this.generateAllTimeSlotsForMonth(
          daysArray,
          dayTimesArray,
          validTimeRanges,
          minDate,
          maxDate,
          sessionTimeLimit,
          selectedYear,
          selectedMonth,
          timeFormat,
          selectedTimezone,
        );
        //this.setState({availableSlotsListsByDate: allTimeSlots});
        //return;

        // Step 2: Populate available mentor IDs for each time slot
        let allAvailableSlots = this.getPopulateMentorAvailabilityForAllSlots(
          allTimeSlots,
          selectedYear,
          selectedMonth,
          selectedTimezone,
          minDate,
          maxDate,
        );

        if (this.isTeamMentor) {
          // this is done to keep structure same for team and single mentor cases.
          // this reduces complexity in team mentor case as we are already doing multiple iterations over mentors in //getPopulateMentorAvailabilityForAllSlots function
          allAvailableSlots = this.normalizeAvailableSlots(
            allAvailableSlots,
            dayTimesArray,
          );
        }
        this.setState({availableSlotsListsByDate: allAvailableSlots}, () => {
          if (recreateBookingOption) {
            this.recreateBookingOption();
          }
        });
      },
    );
  };

  normalizeAvailableSlots = (allAvailableSlots, dayTimesArray) => {
    const normalizedSlots = {};
    // Iterate through each day in allAvailableSlots
    Object.keys(allAvailableSlots).forEach((day) => {
      if (day === ' ') {
        // Handle empty space entries for calendar layout
        normalizedSlots[day] = allAvailableSlots[day];
        return;
      }
      // Create a complete array with all time slots and empty mentor arrays
      const completeTimeSlots = dayTimesArray.map((time) => ({
        time: time,
        availableMentorIds: [], // Default empty array
      }));
      // Update with actual availability data from allAvailableSlots
      const existingSlots = allAvailableSlots[day] || [];
      existingSlots.forEach((existingSlot) => {
        const matchingSlotIndex = completeTimeSlots.findIndex(
          (slot) => slot.time === existingSlot.time,
        );
        if (matchingSlotIndex !== -1) {
          completeTimeSlots[matchingSlotIndex] = existingSlot;
        }
      });
      normalizedSlots[day] = completeTimeSlots;
    });
    return normalizedSlots;
  };

  generateAllTimeSlotsForMonth = (
    daysArray,
    dayTimesArray,
    validTimeRanges,
    minDate,
    maxDate,
    sessionTimeLimit,
    selectedYear,
    selectedMonth,
    timeFormat,
    selectedTimezone,
  ) => {
    const allTimeSlots = {};
    daysArray.forEach((day) => {
      if (day === ' ') {
        // Handle empty space entries for calendar layout
        allTimeSlots[day] = allTimeSlots[day]
          ? [...allTimeSlots[day], ' ']
          : [' '];
        return;
      }
      const actualDayDate = moment()
        .year(selectedYear)
        .month(selectedMonth - 1) // moment months are 0-indexed
        .date(day)
        .startOf('day')
        .valueOf();

      // Filter time slots based on team mentor validation if needed
      let validTimeSlotsForDay = [...dayTimesArray];

      if (this.isTeamMentor) {
        validTimeSlotsForDay = dayTimesArray.filter((time) =>
          this.isTeamMentorTimeValid(
            time,
            actualDayDate,
            validTimeRanges,
            timeFormat,
            selectedTimezone,
            this.props.mentor.mentorDto?.scheduleSettingsDto.timezone,
            minDate,
            maxDate,
            sessionTimeLimit,
          ),
        );
      }
      // Create time slot objects with empty mentor arrays
      allTimeSlots[day] = validTimeSlotsForDay.map((time) => ({
        time: time,
        availableMentorIds: [], // Will be populated in step 2
      }));
    });

    return allTimeSlots;
  };

  getPopulateMentorAvailabilityForAllSlots = (
    allTimeSlots,
    selectedYear,
    selectedMonth,
    selectedTimezone,
    minDate,
    maxDate,
  ) => {
    // OPTIMIZED APPROACH: Process by mentor instead of by slot
    // This reduces complexity from O(days × slots × mentors²) to O(mentors × days × slots)

    let validMentorIds = [this.props.mentor.mentorDto.mentorId];
    if (this.isTeamMentor) {
      validMentorIds = Object.keys(this.mentorsControlMapDto).filter(
        (mentorId) =>
          this.mentorsControlMapDto[
            mentorId
          ]?.extendedMentorDto?.mentorDto.appControlDto?.foregroundWidgets.includes(
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING,
          ),
      );
    }

    for (const mentorId of validMentorIds) {
      // Get mentor data ONCE per mentor (not per slot)
      const mentorData = this.mentorsControlMapDto[mentorId];
      const {availableTimeRanges, timeFormat} =
        mentorData.extendedMentorDto.mentorDto.scheduleSettingsDto;

      const validTimeRange =
        mentorData.extendedMentorDto.mentorDto.scheduleSettingsDto
          .availableTimeRangesSelector ===
        VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.SPECIFIC_TIME
          ? availableTimeRanges || []
          : this.props.mentor.mentorDto.scheduleSettingsDto
                .availableTimeRangesSelector ===
              VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.NO_TIME
            ? []
            : null;

      const mentorTimezone =
        this.props.mentor.mentorDto.scheduleSettingsDto.timezone;
      const sessionTimeLimit =
        this.props.mentor?.sessionTemplateDto?.sessionTimeLimit * 60 * 1000;
      const alreadyBookedMentorTimeRanges =
        this.state.alreadyBookedTimeRanges?.[
          mentorData.extendedMentorDto.mentorDto.mentorOwnerId
        ];
      // Process all days and slots for THIS mentor
      Object.keys(allTimeSlots).forEach((day) => {
        if (day === ' ') {
          // Skip empty space entries
          return;
        }

        const actualDayDate = moment()
          .tz(selectedTimezone)
          .year(selectedYear)
          .month(selectedMonth - 1) // moment months are 0-indexed
          .date(day)
          .startOf('day')
          .valueOf();

        const alreadyBookedMentorTimeRangesForDay =
          alreadyBookedMentorTimeRanges?.get(parseInt(day)) ?? [];

        // Process each time slot for this day and this mentor
        allTimeSlots[day].forEach((slot) => {
          // Check if THIS mentor is available for this specific slot
          const isValid = scheduleUtils.isTimeValid(
            slot.time,
            actualDayDate,
            alreadyBookedMentorTimeRangesForDay,
            validTimeRange,
            timeFormat,
            sessionTimeLimit,
            maxDate,
            selectedTimezone,
            mentorTimezone,
            minDate,
          );

          if (isValid) {
            // Add this mentor to the available mentors for this slot
            slot.availableMentorIds.push(mentorId);
          }
        });
      });
    }
    // Update state with the populated time slots (single state update)
    return allTimeSlots;
  };

  isTeamMentorTimeValid = (
    time,
    date,
    validTimeRanges,
    timeFormat,
    selectedTimezone,
    mentorTimeZone,
    minDate,
    maxDate,
    sessionTimeLimit,
  ) => {
    return (
      scheduleUtils.compareToValidRanges(
        time,
        date,
        validTimeRanges,
        timeFormat,
        selectedTimezone,
        mentorTimeZone,
      ) &&
      scheduleUtils.compareTimeToMinDate(
        time,
        date,
        minDate,
        timeFormat,
        selectedTimezone,
        // null, // fix this once selected time ranges is sorted
        mentorTimeZone,
      ) &&
      scheduleUtils.compareTimeToMaxDate(
        time,
        date,
        maxDate,
        validTimeRanges,
        timeFormat,
        sessionTimeLimit,
        selectedTimezone,
        mentorTimeZone,
      )
    );
  };

  sendGA = () => {
    this.props.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_BOOKING_REQUEST,
    );
  };
  callSendMessageFunc = (msg, msgType, metaData) => {
    this.props.callSendMessageFunc(msg, msgType, metaData);
  };
  dispatchConsoltoEvents = () => {
    this.props.dispatchConsoltoEvents(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_BOOKING_REQUEST,
    );
  };

  recreateBookingOption = () => {
    const initialBookingOption = this.createNewBookingOption(undefined, true);
    this.setState({
      bookingOptions: [initialBookingOption],
    });
  };

  setAlreadyBookedTimeRanges = async (
    startTime,
    endTime,
    updateBookingOptions,
  ) => {
    this.setState({isLoading: true});
    const mentorIdsList = this.isTeamMentor
      ? Object.values(this.mentorsControlMapDto)
          .filter((m) =>
            m?.extendedMentorDto?.mentorDto.appControlDto?.foregroundWidgets.includes(
              VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING,
            ),
          )
          .map((m) => m.extendedMentorDto.mentorDto.mentorOwnerId)
      : [this.props.mentor?.mentorDto?.mentorOwnerId];

    if (mentorIdsList.length > 0) {
      bookingFlowService.getAlreadyBookedTimeRangesByDate(
        mentorIdsList,
        startTime,
        endTime,
        (response) => {
          this.doWhenAlreadyBookedTimeRangesReceived(
            startTime,
            endTime,
            updateBookingOptions,
            response,
          );
        },
        () => {
          console.debug('Error fetching already booked time ranges');
          this.setState({isLoading: false});
        },
      );
    } else {
      this.setState({
        isLoading: false,
        alreadyBookedTimeRangesStartDate: startTime,
        alreadyBookedTimeRangesEndDate: endTime,
      });
      const newSelected = moment(startTime)
        .tz(
          this.state.requestedTimezone ||
            scheduleUtils.generateGuessedTimezone(),
        )
        .valueOf();
      this.generateMentorAvailabilityListForMonth(newSelected);
    }
  };
  doWhenAlreadyBookedTimeRangesReceived = (
    startTime,
    endTime,
    updateBookingOptions,
    response,
  ) => {
    // Set start/end dates
    this.setState({
      alreadyBookedTimeRangesStartDate: startTime,
      alreadyBookedTimeRangesEndDate: endTime,
    });

    // Build alreadyBookedTimeRanges for all mentors from the new response format
    const newAlreadyBookedTimeRanges = {};

    if (response && response.data && response.data.alreadyBookedTimeRanges) {
      // Group bookings by mentorUserId
      response.data.alreadyBookedTimeRanges.forEach((booking) => {
        const mentorUserId = booking.mentorUserId;

        // Convert the booking to the expected format for scheduleUtils.bookedRangesToDateWiseRecords
        const meetingDetails = {
          fromDateTime: booking.fromDateTime,
          toDateTime: booking.toDateTime,
        };

        // Initialize or get existing booked time records for this mentor
        if (!newAlreadyBookedTimeRanges[mentorUserId]) {
          newAlreadyBookedTimeRanges[mentorUserId] = new Map();
        }

        // Add this booking to the mentor's date-wise records
        newAlreadyBookedTimeRanges[mentorUserId] =
          scheduleUtils.bookedRangesToDateWiseRecords(
            newAlreadyBookedTimeRanges[mentorUserId],
            meetingDetails,
            this.state.requestedTimezone,
          );
      });
    }

    this.setState(
      {
        alreadyBookedTimeRanges: newAlreadyBookedTimeRanges,
        isLoading: false,
      },
      () => {
        const newSelected = moment(startTime)
          .tz(
            this.state.requestedTimezone ||
              scheduleUtils.generateGuessedTimezone(),
          )
          .valueOf();

        this.generateMentorAvailabilityListForMonth(newSelected);
      },
    );
  };

  handlePaymentFlowBasedSessionDto = () => {
    const mentorId = this.props.mentor.mentorDto.mentorId;
    const paymentFlowType =
      VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE.IN_SCHEDULING;
    sessionTemplateService.getSessionTemplatesByMentorIdAndSessionType(
      mentorId,
      paymentFlowType,
      (sessionsData) => {
        const paymentFlowBasedSessionDtos = sessionsData?.filter((session) => {
          return session?.paymentFlow === paymentFlowType;
        });
        const paymentFlowBasedSessionDto =
          paymentFlowBasedSessionDtos?.length > 0 &&
          paymentFlowBasedSessionDtos[0]?.sessionCost > 0
            ? paymentFlowBasedSessionDtos[0]
            : null;
        this.setState({
          paymentFlowBasedSessionDto,
        });
      },
      (error) => {
        console.debug('Error: ', error);
        this.setState({
          paymentFlowBasedSessionDto: null,
        });
      },
    );
  };
  createNewBookingOption = (index, isUpdated) => {
    // if availableTimeRangesSelector==SPECIFIC_TIME, Find earliest mentor's availabile timeslot which is not already-booked meeting.
    // else propose this time next day.
    let bookingOptions = [];
    if (!isUpdated) {
      bookingOptions = [...this.state.bookingOptions];
    }
    let last = bookingOptions[bookingOptions.length - 1];
    if (index !== undefined) {
      // get the highest start time value choosen by user
      const lastIndex = new Date(
        Math.max.apply(
          Math,
          bookingOptions.map(function (o) {
            return o.rangeStartTimeSender;
          }),
        ),
      ).getTime();
      // get the highest slot choosen by user
      const highestIndex = bookingOptions.findIndex(
        (booking) => booking.rangeStartTimeSender === lastIndex,
      );
      last = Object.assign({}, bookingOptions[highestIndex]);
    }
    let startTime = this.state.alreadyBookedTimeRangesStartDate
      ? moment(this.state.alreadyBookedTimeRangesStartDate)
          .tz(
            this.state.requestedTimezone ||
              scheduleUtils.generateGuessedTimezone(),
          )
          .valueOf()
      : moment()
          .tz(
            this.state.requestedTimezone ||
              scheduleUtils.generateGuessedTimezone(),
          )
          .valueOf();
    startTime = startTime - (startTime % TIME_STEP) + DAY;

    if (
      this.props.mentor?.mentorDto?.scheduleSettingsDto
        ?.availableTimeRangesSelector ===
      VIDABOO_CONSTANTS.SCHEDULING_AVAILABLE_TIME_OPTIONS.SPECIFIC_TIME
    ) {
      const earliestAvailableSlot = this.findEarliestAvailableTimeSlot();
      startTime = earliestAvailableSlot ?? startTime; // solving case where no available timeslots were found (for example - today, slots have passed)
    }

    if (bookingOptions.length > 0) {
      // add 20 mins to old selected slot to get new slot
      startTime =
        last.rangeStartTimeSender +
          this.props.mentor.sessionTemplateDto?.sessionTimeLimit * 60 * 1000 ??
        DEFAULT_SESSION_TIME;
      const bookingIndex = bookingOptions.findIndex((booking) => {
        return booking.rangeStartTimeSender === startTime;
      });
      if (bookingIndex !== -1) {
        return this.createNewBookingOption(bookingIndex);
      } else {
        return {
          rangeStartTimeSender: startTime,
          rangeEndTimeSender:
            startTime +
              this.props.mentor.sessionTemplateDto?.sessionTimeLimit *
                60 *
                1000 ?? DEFAULT_SESSION_TIME,
        };
      }
    } else {
      startTime = this.findEarliestAvailableTimeSlot() ?? startTime;
      return {
        rangeStartTimeSender: startTime,
        rangeEndTimeSender:
          startTime +
            this.props.mentor.sessionTemplateDto?.sessionTimeLimit *
              60 *
              1000 ?? DEFAULT_SESSION_TIME,
      };
    }
  };
  findEarliestAvailableTimeSlot = () => {
    // debugger;
    // Use availableSlotsListsByDate to find the earliest available slot
    const selectedTimezone =
      this.state.requestedTimezone || scheduleUtils.generateGuessedTimezone();
    let validMentorIds = [this.props.mentor.mentorDto.mentorId];
    if (this.isTeamMentor) {
      validMentorIds = Object.keys(this.mentorsControlMapDto).filter(
        (mentorId) =>
          this.mentorsControlMapDto[
            mentorId
          ]?.extendedMentorDto?.mentorDto.appControlDto?.foregroundWidgets.includes(
            VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING,
          ),
      );
    }
    if (
      this.state.availableSlotsListsByDate &&
      Object.keys(this.state.availableSlotsListsByDate).length > 0
    ) {
      const today = moment().tz(selectedTimezone);
      const currentDay = today.date();
      const currentTime = today.format('HH:mm');
      const timeFormat =
        this.props.mentor.mentorDto?.scheduleSettingsDto.timeFormat;

      // Use the month being processed (from alreadyBookedTimeRangesStartDate) instead of existing booking option
      const processingMonth = this.state.alreadyBookedTimeRangesStartDate
        ? moment(this.state.alreadyBookedTimeRangesStartDate).tz(
            selectedTimezone,
          )
        : today;

      // Sort days numerically, excluding empty space entries
      const sortedDays = Object.keys(this.state.availableSlotsListsByDate)
        .filter((day) => day !== ' ') // Filter out empty space entries
        .map((day) => parseInt(day))
        .sort((a, b) => a - b);

      const isCurrentMonth =
        processingMonth.format('YYYY-MM') === today.format('YYYY-MM');
      for (const day of sortedDays) {
        // For months other than current month, don't skip any days
        // For current month, skip past days

        if (isCurrentMonth && day < currentDay) continue;

        const daySlots = this.state.availableSlotsListsByDate[day] || [];

        for (const slot of daySlots) {
          // Skip slots with no available mentors
          if (!slot.availableMentorIds || slot.availableMentorIds.length === 0)
            continue;

          // For current day in current month, skip past time slots
          if (isCurrentMonth && day === currentDay) {
            const slotTime24h =
              timeFormat === VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
                ? moment(slot.time, 'h:mm A').format('HH:mm')
                : slot.time;

            if (slotTime24h <= currentTime) continue;
          }

          // Found an available slot - convert to timestamp using the processing month
          const timeFormatStr =
            timeFormat === VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
              ? 'h:mm A'
              : 'HH:mm';

          // Not using .add() for hours/minutes: When DST change happens on the same day, adding hours to midnight causes issues.
          // Using .hour() and .minute() setters triggers moment to recalculate the UTC offset correctly.
          const firstAvailableTimeSlot = processingMonth
            .clone()
            .tz(selectedTimezone)
            .startOf('month')
            .add({day: day - 1})
            .hour(parseInt(moment(slot.time, timeFormatStr).format('HH')))
            .minute(parseInt(moment(slot.time, timeFormatStr).format('mm')))
            .valueOf();

          return firstAvailableTimeSlot;
        }
      }

      // If no slots found in current month, trigger loading next month

      const nextMonth = processingMonth.clone().add(1, 'month');
      const currentMonth = moment().tz(selectedTimezone);
      const monthsDifference = nextMonth.diff(currentMonth, 'months');

      // Only load next month if it's within 6 months from current month

      const shouldLoadNextMonth =
        monthsDifference < 6 && validMentorIds.length > 0;

      if (shouldLoadNextMonth) {
        this.setAlreadyBookedTimeRanges(
          nextMonth.startOf('month').startOf('day').valueOf(),
          nextMonth.endOf('month').endOf('day').valueOf(),
          true,
        );
      }

      return null;
    }

    // Fallback: if availableSlotsListsByDate is not ready, return a basic timestamp
    return moment()
      .tz(selectedTimezone)
      .startOf('day')
      .add(9, 'hours') // Default to 9 AM today
      .valueOf();
  };
  getUpdatedBookingFlowInstance(oldBookingFlowInstance, availableMentor) {
    const bookingFlowInstance = {...oldBookingFlowInstance};

    if (!availableMentor) {
      return bookingFlowInstance;
    }
    const selectedExtendedMentorDto = availableMentor; //todo : update
    const selectedMentorDto = selectedExtendedMentorDto.mentorDto; //todo : update
    bookingFlowInstance.sessionTemplateId =
      selectedExtendedMentorDto.sessionTemplateDto?.sessionTemplateId;
    bookingFlowInstance.recipientUserId = selectedMentorDto.mentorOwnerId;
    bookingFlowInstance.mentorUserId = selectedMentorDto.mentorOwnerId;
    bookingFlowInstance.mentorId = selectedMentorDto.mentorId;
    bookingFlowInstance.title = scheduleUtils.getMeetingTitle(
      selectedMentorDto.displayName,
      selectedExtendedMentorDto.sessionTemplateDto,
    );
    return bookingFlowInstance;
  }
  getAvailableMentorForSelectedTimeSlot = (rangeStartTimeSender) => {
    // Convert timestamp to moment in the correct timezone
    const selectedMoment = moment(rangeStartTimeSender).tz(
      this.state.requestedTimezone || scheduleUtils.generateGuessedTimezone(),
    );
    const dayOfMonth = selectedMoment.format('D');
    const timeFormat =
      this.props.mentor.mentorDto?.scheduleSettingsDto.timeFormat;
    const timeSlot =
      timeFormat === VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR
        ? selectedMoment.format('h:mm A') // 12-hour format: "1:30 PM"
        : selectedMoment.format('HH:mm'); // 24-hour format: "13:30"
    const availableMentorIds =
      this.state.availableSlotsListsByDate[dayOfMonth]?.find((slot) => {
        return slot.time === timeSlot;
      })?.availableMentorIds || [];
    if (availableMentorIds.length === 0) {
      return null;
    }
    // randomizing mentor
    const mentorIdOfMentorSelectedForScheduling =
      availableMentorIds[Math.floor(Math.random() * availableMentorIds.length)];
    const extendedMentorDto =
      this.mentorsControlMapDto[mentorIdOfMentorSelectedForScheduling]
        ?.extendedMentorDto;
    return extendedMentorDto;
  };

  submitBookingFlowInstance = (messageToMentor) => {
    if (this.props.isDemo) {
      this.setState({
        showNotificationPopup: true,
        notificationText:
          'Hi, hope you like this demo. To test the scheduling module, please go to the real widget on your website, or to your ClickNTalk page',
        notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.DARK,
        popupAcceptBtnFunc: null,
        popupAcceptBtnText: null,
        popupRejectBtnFunc: null,
        popupRejectBtnText: null,
        popupCloseBtnFunc: this.closePopup,
        popupCloseBtnText: 'OK',
      });
      return;
    }
    this.setState({isBookingFlowRunning: true});

    let bookingFlowInstance = this.state.bookingFlowInstance;

    let selectedMentor = this.props.mentor;

    if (this.isTeamMentor) {
      const availableMentor = this.getAvailableMentorForSelectedTimeSlot(
        this.state.bookingOptions[0].rangeStartTimeSender,
      );
      selectedMentor = availableMentor ?? selectedMentor;
      this.setState({selectedMentorForTeamScheduling: selectedMentor});
      bookingFlowInstance = this.getUpdatedBookingFlowInstance(
        bookingFlowInstance,
        availableMentor,
      );
    }

    bookingFlowInstance.bookingOptions = {};

    this.state.bookingOptions.forEach((bookingOption, index) => {
      // bookingOption.rangeStartTimeSender = scheduleUtils.getTimeAfterTzShift(
      //   bookingOption.rangeStartTimeSender,
      //   this.state.requestedTimezone,
      // );
      // bookingOption.rangeEndTimeSender = scheduleUtils.getTimeAfterTzShift(
      //   bookingOption.rangeEndTimeSender,
      //   this.state.requestedTimezone,
      // );
      bookingFlowInstance.bookingOptions[index] =
        scheduleUtils.getModifiedBookingOption(
          bookingOption,
          this.state.requestedTimezone,
        );
    });
    let userEmail = null,
      userName = null,
      message = null;
    Object.values(messageToMentor.content).forEach((val) => {
      if (val.field_name === 'email') userEmail = val.answers;
      if (val.field_name === 'name') userName = val.answers;
      if (val.field_name === 'message') message = val.answers;
    });
    bookingFlowInstance.creationTimeSender = new Date().getTime();
    // bookingFlowInstance.requesterEmail = userEmail;
    bookingFlowInstance.notes = message;
    bookingFlowInstance.requestedTimezone = this.state.requestedTimezone;
    const newUserObj = {
      email: userEmail,
      firstName: userName,
      // phoneNumber: this.state.phoneNumber
      timezone: bookingFlowInstance.requestedTimezone,
    };
    // debugger;
    userService.createEmailUser(
      newUserObj,
      (response) => {
        // success
        bookingFlowInstance.requester = {
          userId: response.userDto.userId,
          status: VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CONFIRMED,
          email: userEmail,
        };
        let recipients = [...this.state.recipients];
        const mentorObj = {
          userId: selectedMentor.mentorDto.mentorOwnerId,
          email: selectedMentor.mentorDto.publicEmail, //TODO:Ilan need to verify this bit is OK?
          status: VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CREATED,
        };
        if (recipients.length) {
          let emailUserCreatedCount = 0;
          recipients.forEach((recipient, idx) => {
            const newUserObj = {
              email: recipient.email,
              timezone: bookingFlowInstance.requestedTimezone,
            };
            userService.createEmailUser(
              newUserObj,
              (response) => {
                recipients[idx] = {
                  email: recipients[idx].email,
                  userId: response.userDto.userId,
                  status: VIDABOO_CONSTANTS.BOOKING_FLOW_USER_STATES.CREATED,
                };
                emailUserCreatedCount++;
                if (emailUserCreatedCount === recipients.length) {
                  bookingFlowInstance.recipients = [mentorObj, ...recipients];
                  if (this.state.paymentFlowBasedSessionDto) {
                    bookingFlowService.createReserveBfi(
                      bookingFlowInstance,
                      (response) => {
                        this.doWhenBookingFlowInstanceCreated(response);
                      },
                      this.handleErrors,
                    );
                  } else {
                    bookingFlowService.createBookingFlowInstance(
                      bookingFlowInstance,
                      (response) => {
                        this.doWhenBookingFlowInstanceCreated(response);
                      },
                      this.handleErrors,
                    );
                  }
                }
              },
              this.handleErrors,
            );
          });
        } else {
          // requesterUserId = response.userDto.userId;
          bookingFlowInstance.recipients = [mentorObj];
          if (this.state.paymentFlowBasedSessionDto) {
            bookingFlowService.createReserveBfi(
              bookingFlowInstance,
              (response) => {
                this.doWhenBookingFlowInstanceCreated(response);
              },
              this.handleErrors,
            );
          } else {
            bookingFlowService.createBookingFlowInstance(
              bookingFlowInstance,
              (response) => {
                this.doWhenBookingFlowInstanceCreated(response);
              },
              this.handleErrors,
            );
          }
        }
      },
      this.handleErrors,
    );
    this.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.FRONT_PAGE.SEND_BOOKING_REQUEST,
      this.props.mentor.mentorDto.profileName,
    );
    this.props.dispatchConsoltoEvents &&
      this.dispatchConsoltoEvents(
        VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_BOOKING_REQUEST,
      );
  };
  handleErrors = (response) => {
    console.debug('failed to create bookingFlowInstance, Error:', response);
    const errorCode = response?.code;
    const notificationText =
      STRINGS.ERROR_MESSAGES.SCHEDULING[response?.code] ??
      this.context.languageSet.SCHEDULING.INVITATION_FAILED;
    console.debug('Scheduling error: ' + errorCode);
    this.setState({
      showNotificationPopup: true,
      notificationText: notificationText,
      //"Ohh... something went wrong... Please check that the meeting times aren't in the past",
      notificationType: VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
      popupAcceptBtnFunc: null,
      popupAcceptBtnText: null,
      popupRejectBtnFunc: null,
      popupRejectBtnText: null,
      popupCloseBtnFunc:
        response?.code === 'BFE-010'
          ? this.restartSchedulingFlow
          : this.closePopup,
      popupCloseBtnText: 'OK',
      isBookingFlowRunning: false,
      showUpdateMeetingSpinner: false,
      showCancelMeetingSpinner: false,
    });
  };
  closePopup = () => {
    this.setState({
      showNotificationPopup: false,
    });
  };
  doWhenBookingFlowInstanceCreated = (bookingFlowInstanceDto) => {
    console.debug(
      'Successfully created booking flow instance',
      bookingFlowInstanceDto,
    );
    if (
      bookingFlowInstanceDto.status ===
      VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.RESERVED
    ) {
      this.setState({
        shouldStartPaymentFlow: true,
        paymentDtoBfiId: bookingFlowInstanceDto.bookingFlowInstanceId,
      });
    } else {
      this.callSendMessageFunc(
        'Appointment Request',
        VIDABOO_CONSTANTS.CHAT_SUBTYPES.SCHEDULE_MEETING,
        bookingFlowInstanceDto.bookingFlowInstanceId,
      );
      this.setState({
        schedulingStep: 2,
        showSuccessComponent: true,
        isBookingFlowRunning: false,
      });
    }
  };

  doWhenPaymentFlowCompletedSuccessfully = (response) => {
    const status = response.status;
    if (status === VIDABOO_CONSTANTS.C2C_CUSTOMER_PAYMENT_SUCCESSFUL_STATUS) {
      this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS);
      this.callSendMessageFunc(
        'Appointment Request',
        VIDABOO_CONSTANTS.CHAT_SUBTYPES.SCHEDULE_MEETING,
        this.state.paymentDtoBfiId,
      );
      this.setState({
        schedulingStep: 2,
        showSuccessComponent: true,
        isBookingFlowRunning: false,
        paymentDtoBfiId: null,
      });
    } else {
      this.handleToast(VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE);
      this.restartSchedulingFlow(true);
    }
  };

  restartSchedulingFlow = (isPaymentFlow) => {
    if (this.props.mentor?.mentorDto?.scheduleSettingsDto?.autoMentorApproval) {
      const startTime = this.state.alreadyBookedTimeRangesStartDate;
      const endTime = this.state.alreadyBookedTimeRangesEndDate;
      this.setAlreadyBookedTimeRanges(startTime, endTime, true);

      if (isPaymentFlow) {
        const isStepSchedulingFlow =
          this.props.isDemo ||
          utilsService.getIsInWidget() ||
          (utilsService.getIsPersonalPage() &&
            this.context.windowScreenSize ===
              VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE);
        if (isStepSchedulingFlow) {
          this.recreateBookingOption();
          this.moveSchedulingStep(0, false);
        } else {
          this.setState({shouldRestartSchedulingFlow: true});
        }
      }
    } else {
      this.recreateBookingOption();
    }

    this.setState({
      isBookingFlowRunning: false,
      shouldStartPaymentFlow: false,
      showNotificationPopup: false,
      paymentDtoBfiId: null,
    });
  };

  rejectPayment = () => {
    bookingFlowService.cancelReservedBfi(
      this.state.paymentDtoBfiId,
      (response) => {
        if (response.success) {
          this.restartSchedulingFlow(true);
          this.handleToast(
            VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS,
            'Meeting not reserved',
          );
        } else {
          this.handleToast(
            VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
            'Failed to update meeting. Please try again.',
          );
        }
      },
      (error) => {
        console.debug('Error: ', error);
        this.handleToast(
          VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
          'Failed to update meeting. Please try again.',
        );
      },
    );
  };

  handleToast = (toastType, toastTitle) => {
    const tempToastText = toastTitle
      ? toastTitle
      : toastType === VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.SUCCESS
        ? 'Payment success'
        : 'Payment failed';
    const toastObj = utilsService.getToastObj({
      toastTitle: tempToastText,
      toastType,
    });
    this.context.addToastObj(toastObj);
  };

  setShouldRestartSchedulingFlow = (shouldRestartSchedulingFlow) => {
    this.setState({shouldRestartSchedulingFlow});
  };

  popupDatePicker = (index) => {
    const bookingOption = this.state.bookingOptions[index];
    this.setState({
      bookingOptionToEdit: bookingOption,
    });
  };
  addBookingOption = () => {
    const newBookingOption = this.createNewBookingOption();
    const bookingOptions = [...this.state.bookingOptions];
    bookingOptions.push(newBookingOption);
    this.setState({bookingOptions}, () => {
      this.popupDatePicker(this.state.bookingOptions.length - 1);
    });
  };

  deleteBookingOption = (index) => {
    const bookingOptions = [...this.state.bookingOptions];
    bookingOptions.splice(index, 1);
    this.setState({bookingOptions});
  };
  updateBookingOption = (index, bookingOption) => {
    if (this.props.isDemo) return;
    bookingOption.rangeEndTimeSender =
      bookingOption.rangeStartTimeSender +
      (this.props.mentor.sessionTemplateDto?.sessionTimeLimit
        ? this.props.mentor.sessionTemplateDto.sessionTimeLimit * 1000 * 60
        : DEFAULT_SESSION_TIME);
    const bookingOptions = [...this.state.bookingOptions];
    bookingOptions[index] = {...bookingOption};
    this.setState({bookingOptions});
  };

  updateBookingOptionForDate = (index, bookingOption) => {
    if (this.props.isDemo) return;

    const date = moment(bookingOption?.rangeStartTimeSender)
      .tz(this.state.requestedTimezone)
      .startOf('day');
    const dayOfMonth = Number(moment(date).format('D'));

    // Use availableSlotsListsByDate to find the first available slot for this day
    const availableSlotsForDay =
      this.state.availableSlotsListsByDate[dayOfMonth] || [];

    // Find the first slot that has available mentors
    const firstAvailableSlot = availableSlotsForDay.find(
      (slot) => slot.availableMentorIds && slot.availableMentorIds.length > 0,
    );

    if (firstAvailableSlot) {
      // Parse the time from the available slot
      const timeFormat =
        this.props.mentor.mentorDto?.scheduleSettingsDto.timeFormat;
      let slotMoment;

      if (timeFormat === VIDABOO_CONSTANTS.TIME_FORMAT.TWELVE_HOUR) {
        // Parse 12-hour format (e.g., "1:30 PM")
        slotMoment = moment(firstAvailableSlot.time, 'h:mm A');
      } else {
        // Parse 24-hour format (e.g., "13:30")
        slotMoment = moment(firstAvailableSlot.time, 'HH:mm');
      }

      // Set the booking option to this day and time
      // Not using .add() for hours/minutes: When DST change happens on the same day, adding hours to midnight causes issues.
      // Using .hour() and .minute() setters triggers moment to recalculate the UTC offset correctly.
      bookingOption.rangeStartTimeSender = moment(
        bookingOption.rangeStartTimeSender,
      )
        .tz(this.state.requestedTimezone)
        .startOf('day')
        .hour(slotMoment.hour())
        .minute(slotMoment.minute())
        .valueOf();

      bookingOption.rangeEndTimeSender =
        bookingOption.rangeStartTimeSender +
        (this.props.mentor.sessionTemplateDto?.sessionTimeLimit
          ? this.props.mentor.sessionTemplateDto.sessionTimeLimit * 1000 * 60
          : DEFAULT_SESSION_TIME);

      const bookingOptions = [...this.state.bookingOptions];
      bookingOptions[index] = {...bookingOption};
      this.setState({bookingOptions});
    } else {
      // No available slots for this day - fallback to old logic or show error
      console.warn('No available slots found for day:', dayOfMonth);
      const bookingOptions = [...this.state.bookingOptions];
      bookingOptions[index] = {...bookingOption};
      this.setState({bookingOptions});
    }
  };

  updateBookedTimeRangesAPIDates = (prevTimezone, newTimezone) => {
    const prevStartDate = moment(
      this.state.alreadyBookedTimeRangesStartDate,
    ).tz(prevTimezone);
    const newStartDate = moment(this.state.alreadyBookedTimeRangesStartDate)
      .tz(newTimezone)
      .set({month: prevStartDate.get('month')})
      .startOf('month')
      .startOf('day');
    const newEndDate = moment(this.state.alreadyBookedTimeRangesEndDate)
      .tz(newTimezone)
      .set({month: prevStartDate.get('month')})
      .endOf('month')
      .endOf('day');
    this.setState({
      alreadyBookedTimeRangesStartDate: newStartDate.valueOf(),
      alreadyBookedTimeRangesEndDate: newEndDate.valueOf(),
    });
  };
  setTimezone = (timezone) => {
    this.updateBookedTimeRangesAPIDates(this.state.requestedTimezone, timezone);
    const bookingFlowInstance = {...this.state.bookingFlowInstance};
    bookingFlowInstance.requestedTimezone = timezone;
    this.setState({bookingFlowInstance, requestedTimezone: timezone}, () => {
      this.generateMentorAvailabilityListForMonth();
    });
  };
  moveSchedulingStep = (nextStep, finishedStep1) => {
    this.setState({schedulingStep: nextStep, finishedStep1: finishedStep1});
  };
  // setNotes = (notes) => {
  //   const bookingFlowInstance = {...this.state.bookingFlowInstance};
  //   bookingFlowInstance.notes = notes;
  //   this.setState({bookingFlowInstance});
  // };
  setShowSuccessComponent = (isVisible) => {
    this.setState({showSuccessComponent: isVisible});
  };

  setRecipientEmail = (recipientEmail) => {
    this.setState({recipientEmail});
  };

  addRecipientEmail = () => {
    if (this.state.recipientEmail?.length) {
      let tempRecipients = [...this.state.recipients];
      tempRecipients.push({
        email: this.state.recipientEmail,
        isValid: VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL.test(
          this.state.recipientEmail,
        ),
      });
      this.setState({
        recipients: [...tempRecipients],
        areAllEmailsValid: this.areAllRecipientEmailsValid(tempRecipients),
      });
      this.setRecipientEmail('');
    }
  };

  editRecipientEmail = (idx, email) => {
    if (email.length === 0) {
      this.removeRecipient(idx);
    } else {
      let tempRecipients = [...this.state.recipients];
      tempRecipients[idx] = {
        email,
        isValid: VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL.test(email),
      };
      this.setState({
        recipients: [...tempRecipients],
        areAllEmailsValid: this.areAllRecipientEmailsValid(tempRecipients),
      });
    }
  };

  removeRecipient = (idx) => {
    let tempRecipients = [...this.state.recipients];
    tempRecipients.splice(idx, 1);
    this.setState({
      recipients: [...tempRecipients],
      areAllEmailsValid: this.areAllRecipientEmailsValid(tempRecipients),
    });
  };

  areAllRecipientEmailsValid = (recipients) => {
    if (recipients.length === 0) return true;
    return !recipients.find(
      (recipient) =>
        !VIDABOO_CONSTANTS.VALIDATION_PATTERNS.EMAIL.test(recipient.email),
    );
  };

  getRecipientsListWithAddButtonComp = () => {
    const showStepSchedulingFlow =
      this.props.isDemo ||
      utilsService.getIsInWidget() ||
      (utilsService.getIsPersonalPage() &&
        this.context.windowScreenSize === VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE);

    if (this.state.bookingOptions?.length > 1) {
      if (this.state.recipients?.length > 0) {
        this.setState({recipients: [], areAllEmailsValid: true});
      }
      return (
        <>
          <div className="et-n-csrq-add-guest-wrap et-n-csrq-add-guest-wrap-disabled">
            <div className="et-n-csrq-plus-sign">+</div>
            <div>Add guest</div>
          </div>
          <div className="et-n-csrq-multiple-attendees-txt">
            Multi-option currently not supported together with multiple
            attendees
          </div>
        </>
      );
    } else {
      return (
        <div
          className={`${
            showStepSchedulingFlow
              ? 'et-n-widget-melc-container'
              : 'et-n-clickntalk-melc-container'
          }`}>
          <>
            {!this.state.isAddGuestBtnClicked ? (
              <div
                className="et-n-csrq-add-guest-wrap"
                onClick={() => {
                  this.setState({isAddGuestBtnClicked: true});
                }}>
                <div className="et-n-csrq-plus-sign">+</div>
                <div>Add guest</div>
              </div>
            ) : (
              <>
                <div className="et-n-csrq-guest-email-wrap">Guest email</div>
                <MultipleTextPillComponent
                  showStatusIcon={false}
                  recipients={this.state.recipients}
                  newRecipientEmail={this.state.recipientEmail}
                  showError={!this.state.areAllEmailsValid}
                  disableAdditionOfTextPills={
                    this.state.bookingOptions?.length > 1 &&
                    this.state.recipients.length > 0
                  }
                  setNewRecipientEmail={this.setRecipientEmail}
                  addRecipientEmail={this.addRecipientEmail}
                  editRecipientEmail={this.editRecipientEmail}
                  removeRecipient={this.removeRecipient}
                />
              </>
            )}
          </>
        </div>
      );
    }
  };

  render() {
    const widgetLanguageLocaleKey = this.context.currentLanguageLocaleKey;
    const showStepSchedulingFlow =
      this.props.isDemo ||
      utilsService.getIsInWidget() ||
      (utilsService.getIsPersonalPage() &&
        this.context.windowScreenSize === VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE);
    return (
      <div
        className={`et-client-schedule-request-container ${showStepSchedulingFlow ? 'et-widget-body-content-wrap' : ''}`}>
        {this.state.shouldStartPaymentFlow &&
          this.state.paymentFlowBasedSessionDto &&
          this.state.paymentDtoBfiId && (
            <div className="et-csrc-payment-component-wrap">
              <Suspense fallback={<SuspenseLoader />}>
                <C2cPaymentComponent
                  shouldAutoCancelPayment
                  shouldStartPaymentFlow={this.state.shouldStartPaymentFlow}
                  currentUser={this.context.getCurrentUser()}
                  mentorDto={this.props.mentor.mentorDto}
                  sessionTemplateDto={this.state.paymentFlowBasedSessionDto}
                  bookingFlowInstanceId={this.state.paymentDtoBfiId}
                  chatRoomId={this.props?.widgetContext.chatRoomId}
                  paymentFlowType={
                    VIDABOO_CONSTANTS.C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE
                      .IN_SCHEDULING
                  }
                  doWhenPaymentFlowCompletedSuccessfully={
                    this.doWhenPaymentFlowCompletedSuccessfully
                  }
                  rejectPayment={this.rejectPayment}
                />
              </Suspense>
            </div>
          )}
        {this.state.showNotificationPopup && (
          <NotificationComponent
            notificationType={this.state.notificationType}
            notificationTxt={this.state.notificationText}
            acceptBtnTxt={this.state.popupAcceptBtnText}
            acceptBtnFunc={this.state.popupAcceptBtnFunc}
            closeBtnTxt={this.state.popupCloseBtnText}
            closeBtnFunc={this.state.popupCloseBtnFunc}
          />
        )}
        {showStepSchedulingFlow ? (
          this.state.schedulingStep === 0 ? (
            <SchedulingInWidgetStep1
              mentor={this.props.mentor}
              timeIntervals={
                this.props.mentor?.mentorDto?.scheduleSettingsDto
                  ?.startTimeSlotJumps || TIME_STEP_MINUTES
              }
              selectedTimezone={
                this.state.requestedTimezone ||
                scheduleUtils.generateGuessedTimezone()
              }
              recipients={this.state.recipients}
              setSelectedTimezone={this.setTimezone}
              bookingOptions={this.state.bookingOptions}
              addBookingOption={this.addBookingOption}
              deleteBookingOption={this.deleteBookingOption}
              moveSchedulingStep={this.moveSchedulingStep}
              updateBookingOptionForDate={this.updateBookingOptionForDate}
              updateBookingOption={this.updateBookingOption}
              finishedStep1={this.state.finishedStep1}
              isDemo={this.props.isDemo}
              alreadyBookedTimeRanges={this.state.alreadyBookedTimeRanges}
              setAlreadyBookedTimeRanges={this.setAlreadyBookedTimeRanges}
              isLoading={this.state.isLoading}
              widgetLanguageLocaleKey={widgetLanguageLocaleKey}
              paymentFlowBasedSessionDto={this.state.paymentFlowBasedSessionDto}
              availableSlotsListsByDate={this.state.availableSlotsListsByDate}
              generateMentorAvailabilityListForMonth={
                this.generateMentorAvailabilityListForMonth
              }
              isTeamMentor={this.isTeamMentor}
            />
          ) : this.state.schedulingStep === 1 ? (
            <SchedulingInWidgetStep2
              isDemo={this.props.isDemo}
              mentor={this.props.mentor}
              moveSchedulingStep={this.moveSchedulingStep}
              submitBookingFlow={this.submitBookingFlowInstance}
              isAutoApprovalEnabled={
                this.props.mentor?.mentorDto?.scheduleSettingsDto
                  ?.autoMentorApproval
              }
              isBookingFlowRunning={this.state.isBookingFlowRunning}
              callSendMessageFunc={this.callSendMessageFunc}
              getRecipientsListWithAddButtonComp={
                this.getRecipientsListWithAddButtonComp
              }
              areAllEmailsValid={this.state.areAllEmailsValid}
              paymentFlowBasedSessionDto={this.state.paymentFlowBasedSessionDto}
            />
          ) : (
            <SchedulingInWidgetStep3
              isAutoApprovalOn={
                this.props.mentor?.mentorDto?.scheduleSettingsDto
                  ?.autoMentorApproval
              }
              bookingOptions={this.state.bookingOptions}
              mentor={
                this.state.selectedMentorForTeamScheduling ?? this.props.mentor
              }
              selectedTimezone={
                this.state.requestedTimezone ||
                scheduleUtils.generateGuessedTimezone()
              }
              timeFormat={
                this.props.mentor?.mentorDto?.scheduleSettingsDto?.timeFormat
              }
              moveSchedulingStep={this.moveSchedulingStep}
              recreateBookingOption={this.recreateBookingOption}
              restartSchedulingFlow={this.restartSchedulingFlow}
            />
          )
        ) : (
          <div className="et-client-schedule-invitation-container">
            <ClientSchedulingInvitationComponent
              isDemo={this.props.isDemo}
              bookingOptions={this.state.bookingOptions}
              recipients={this.state.recipients}
              newBfiDto={this.state.bookingFlowInstance}
              addBookingOption={this.addBookingOption}
              currentUserId={this.state.bookingFlowInstance?.requester?.userId}
              deleteBookingOption={this.deleteBookingOption}
              updateBookingOption={this.updateBookingOption}
              updateBookingOptionForDate={this.updateBookingOptionForDate}
              submitNewBookingFlowInstance={this.submitBookingFlowInstance}
              extendedMentorDto={this.props.mentor}
              timeIntervals={
                this.props.mentor?.mentorDto?.scheduleSettingsDto
                  ?.startTimeSlotJumps || TIME_STEP_MINUTES
              }
              selectedTimezone={this.state.requestedTimezone}
              setSelectedTimezone={this.setTimezone}
              bookingOptionRecentlyAddedIndex={
                this.state.bookingOptionRecentlyAddedIndex
              }
              alreadyBookedTimeRanges={this.state.alreadyBookedTimeRanges}
              setAlreadyBookedTimeRanges={this.setAlreadyBookedTimeRanges}
              moveSchedulingStep={this.moveSchedulingStep}
              recreateBookingOption={this.recreateBookingOption}
              showSuccessComponent={this.state.showSuccessComponent}
              setShowSuccessComponent={this.setShowSuccessComponent}
              isLoading={this.state.isLoading}
              isBookingFlowRunning={this.state.isBookingFlowRunning}
              widgetLanguageLocaleKey={widgetLanguageLocaleKey}
              callSendMessageFunc={this.callSendMessageFunc}
              getRecipientsListWithAddButtonComp={
                this.getRecipientsListWithAddButtonComp
              }
              areAllEmailsValid={this.state.areAllEmailsValid}
              paymentFlowBasedSessionDto={this.state.paymentFlowBasedSessionDto}
              restartSchedulingFlow={this.restartSchedulingFlow}
              shouldRestartSchedulingFlow={
                this.state.shouldRestartSchedulingFlow
              }
              setShouldRestartSchedulingFlow={
                this.setShouldRestartSchedulingFlow
              }
              generateMentorAvailabilityListForMonth={
                this.generateMentorAvailabilityListForMonth
              }
              availableSlotsListsByDate={this.state.availableSlotsListsByDate}
            />
          </div>
        )}
      </div>
    );
  }
}
ClientScheduleRequestContainer.contextType = AppContext;
export default withWidgetContext(ClientScheduleRequestContainer);
